import React from "react";
import { useParams } from "react-router-dom";

const TITULOS_PAGINAS = {
  // ÁREAS CONSTRUÍDAS
  "tipo-area": "TIPO ÁREA",
  "area-terrenos-urbanizados-nao-urbanizados": "ÁREA TERRENOS URBANIZADOS E NÃO URBANIZADOS",
  "tipo-area-urbanizada": "TIPO ÁREA URBANIZADA",
  "setores-subsetores": "SETORES E SUBSETORES",
  "tipo-area-construida": "TIPO ÁREA CONSTRUÍDA",
  "vagas-estacionamento": "VAGAS ESTACIONAMENTO",
  docas: "DOCAS",
  pallet: "PALLET",
  "sistemas-construtivos": "SISTEMAS CONSTRUTIVOS",
  "instalacoes-equipamentos": "INSTALAÇÕES E EQUIPAMENTOS",

  // UNIDADES LOCÁVEIS
  "lancamento-mensal": "LANÇAMENTO MENSAL",

  // WORKFLOW CONTRATO LOCAÇÃO
  "vistoria-inicial": "VISTORIA INICIAL",
  "entrega-chave": "ENTREGA CHAVE",
  aditivos: "ADITIVOS",
  "vistorias-intermed": "VISTORIAS INTERMED.",
  "confissoes-divida": "CONFISSÕES DE DÍVIDA",
  "aviso-previo": "AVISO PRÉVIO",
  "vistoria-final": "VISTORIA FINAL",
  distrato: "DISTRATO",

  // WORKFLOW OUTROS CONTRATOS
  "informacoes-editaveis": "INFORMAÇÕES EDITÁVEIS",
  contrato: "CONTRATO",

  // TEMPLATES
  "contrato-locacao": "CONTRATO DE LOCAÇÃO",
  "outros-contratos": "OUTROS CONTRATOS",
  // ADMINISTRAÇÃO
  "perfil-acesso": "PERFIL DE ACESSO",
};

function EmDesenvolvimento({ tituloPrincipal = "ÁREAS CONSTRUÍDAS", secao }) {
  const { slug } = useParams();

  const titulo = TITULOS_PAGINAS[slug] || tituloPrincipal;

  return (
    <div className="w-full">
      <h1 className="mb-6 text-2xl font-semibold text-gray-900 dark:text-white">{tituloPrincipal}</h1>

      <div className="rounded-lg border border-gray-300 bg-white p-8 shadow-sm dark:border-gray-700 dark:bg-[#1c1f26]">
        <div className="mb-2 text-sm font-semibold uppercase text-gray-500 dark:text-gray-400">{secao}</div>

        <div className="mb-8 text-xl font-semibold text-gray-900 dark:text-white">{titulo}</div>

        <div className="rounded-md border border-dashed border-gray-400 p-10 text-center dark:border-gray-600">
          <span className="text-xl font-semibold text-gray-600 dark:text-gray-300">EM DESENVOLVIMENTO</span>
        </div>
      </div>
    </div>
  );
}

export default EmDesenvolvimento;
